<template>
    <v-tooltip
        v-if="isIconVisible"
        v-model="isTooltipVisible"
        bottom
    >
        <template #activator="{ on, attrs }">
            <v-icon
                @click="isTooltipVisible = ! isTooltipVisible"
                color="warning"
                v-on="on"
                v-bind="attrs"
                class="mr-4"
            >
                mdi-alert
            </v-icon>
        </template>

        Perbaikan sistem
        <br><strong>17 September 2022, 03:00 - 03:30 WIB</strong>
    </v-tooltip>
</template>

<script>
import { currentMaintenanceDate, dismissedMaintenances } from "./currentMaintenance"
import moment from '@/plugins/moment'

export default {
    data: () => ({
        isTooltipVisible: false,
    }),

    computed: {
        isIconVisible() {
            return dismissedMaintenances.includes(currentMaintenanceDate.toISOString())
                && moment() <= currentMaintenanceDate
        }
    }
}
</script>
